import gql from "graphql-tag";

export const RESET_PASSWORD_MUTATION = gql`
  mutation resetPassword(
    $accessToken: String!
    $oldPassword: String!
    $newPassword: String!
  ) {
    resetPassword(
      accessToken: $accessToken
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      success
      message
    }
  }
`;

export const SEND_SUGGESTION = gql`
  mutation sendSuggestion($sugerencia: String) {
    sendSuggestion(sugerencia: $sugerencia)
  }
`;

export const UPDATE_PROFILE = gql`
  mutation editProfile(
    $id: Int!
    $group: String!
    $nombre: String
    $primer_apellido: String
    $segundo_apellido: String
    $email: String
    $telefono: String
  ) {
    editProfile(
      input: {
        id: $id
        group: $group
        nombre: $nombre
        primer_apellido: $primer_apellido
        segundo_apellido: $segundo_apellido
        email: $email
        telefono: $telefono
      }
    ) {
      error
    }
  }
`;
